import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import {socketModule} from './plugin/socket.io'
import {defaultModule} from './plugin/default.store'
import {firebaseModule} from './plugin/firebase.store'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    socketModule,
    defaultModule,
    firebaseModule
  },
  plugins: [
    createPersistedState({
      paths: [
        'defaultModule.accessToken',
        'defaultModule.refreshToken',
        'defaultModule.projectListOnlyMe',
        'defaultModule.projectOnlyOn',
        'defaultModule.sideBarToggle',
        'socketModule.surveyLogTF'
      ]
    })
  ]
})
export default store



// WEBPACK FOOTER //
// ./src/store.js